import clsx from "clsx";
import React from "react";
import AccordionItem from "../molecules/AccordionItem";
export default function Accordion(props) {
    var _props_cta, _props_cta1, _props_cta2;
    return /*#__PURE__*/ React.createElement("div", {
        className: "page-container my-12 md:mb-24 first:mt-0 lg:first:mt-0 lg:mt-20 last:mb-0 last:md:mb-4"
    }, /*#__PURE__*/ React.createElement("div", {
        className: clsx("", {
            "text-center mb-9": props.cta
        })
    }, /*#__PURE__*/ React.createElement("h2", {
        className: clsx("text-2xl md:text-3xl lg:text-4xl mb-4", {
            "lg:mb-12": !props.cta,
            "lg:mb-7": props.cta
        })
    }, props.sectionHeading), ((_props_cta = props.cta) === null || _props_cta === void 0 ? void 0 : _props_cta.label) && /*#__PURE__*/ React.createElement("a", {
        href: "".concat((_props_cta1 = props.cta) === null || _props_cta1 === void 0 ? void 0 : _props_cta1.target),
        className: "button-secondary w-full sm:w-auto border-gray-600 text-white bg-gray-600 hover:text-gray-600 hover:bg-white"
    }, (_props_cta2 = props.cta) === null || _props_cta2 === void 0 ? void 0 : _props_cta2.label)), /*#__PURE__*/ React.createElement("div", null, props.accordions.map(function(accordion, index) {
        /*#__PURE__*/ return React.createElement("div", {
            key: index,
            className: "border-b border-b-gray-500 last:border-0",
            id: accordion === null || accordion === void 0 ? void 0 : accordion.anchorId
        }, /*#__PURE__*/ React.createElement(AccordionItem, {
            title: accordion.title,
            markup: accordion.markup
        }));
    })));
}
